'use strict';

module Patersons {

    export class ReportTypeSelectComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/reportTypeSelect.component.html';
        controller: any = ReportTypeSelectController;
        bindings: any = {     
            isDisabled: '<',
            onReportTypeChange: '&'
        };
    }
    export interface ReportTypeSelectScope extends ng.IScope {
        events: Patersons.ReportTypeSelectController;
        items: any;
        menuOpen: boolean
        userCompany: UserCompany;
      }
    export class ReportTypeSelectController {
        private $ctrl: any;
        scope: Patersons.ReportTypeSelectScope;
        state: angular.ui.IStateService;
        location: angular.ILocationService;
        stateParams: angular.ui.IStateProvider;
        userCompanyService: Patersons.UserCompanyService;
        key: string;
    
        static $inject = ['$scope', '$location', '$state', '$stateParams','userCompanyService'];

        constructor($scope, $location, $state, $stateParams,userCompanyService){
            this.$ctrl = this;
            this.scope = $scope;
            this.scope.events = this;
            this.scope.menuOpen = false;
            this.userCompanyService = userCompanyService;

            this.userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
            })
            
        }
    }
}